// Recovered compiled webpack factory 28406. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "getPathMatch", {
      enumerable: !0,
      get: function () {
        return a;
      },
    }));
  let n = r(80413);
  function a(e, t) {
    let r = [],
      a = (0, n.pathToRegexp)(e, r, {
        delimiter: "/",
        sensitive: "boolean" == typeof (null == t ? void 0 : t.sensitive) && t.sensitive,
        strict: null == t ? void 0 : t.strict,
      }),
      o = (0, n.regexpToFunction)(
        (null == t ? void 0 : t.regexModifier) ? new RegExp(t.regexModifier(a.source), a.flags) : a,
        r,
      );
    return (e, n) => {
      if ("string" != typeof e) return !1;
      let a = o(e);
      if (!a) return !1;
      if (null == t ? void 0 : t.removeUnnamedParams)
        for (let e of r) "number" == typeof e.name && delete a.params[e.name];
      return { ...n, ...a.params };
    };
  }
}
